<template>
  <div>
    <popup v-if="showPopup" @close="handleClose">
      <div class="justify-content-center text-left" slot="popupMainContent">
        <h2><icon class="mr-1" type="robot" /> Important Notice</h2>
        <p class="important-msg form-error p-3 mb-2 margin-auto">
          <b>Important Notice Regarding vSTAGE Project Opening Times</b><br />

          Dear Customers,<br />
          <br />
          Starting tomorrow, July 16, due to a recent update, opening a vSTAGE project may take significantly longer the first time you open it. This is a one-time process required to apply the changes introduced by the update.
          From the second time onward, project loading times will return to normal.<br />
          We strongly recommend opening your projects ahead of important presentations, allowing for some extra time.
          Thank you for your understanding. If you have any questions, our support team is happy to help.<br /><br />
          Best regards,<br />
          Your Side Effects Team
        </p>
        <p class="important-msg form-error p-3 mb-2 margin-auto">
          <b>Wichtiger Hinweis zum Öffnen von vSTAGE-Projekten</b><br />
          Liebe Kundinnen und Kunden,<br />
<br />
          aufgrund eines aktuellen Updates kann das Öffnen eines vSTAGE-Projekts ab morgen, 16.7. deutlich länger dauern als gewohnt. Dieser Schritt ist einmalig notwendig, um die Änderungen durch das Update zu übernehmen.
          Ab dem zweiten Öffnen wird die Ladezeit wieder wie gewohnt normal sein.<br />
          Wir empfehlen daher, Ihre Projekte rechtzeitig vor wichtigen Präsentationen zu öffnen und dafür etwas zusätzliche Zeit einzuplanen.
          Vielen Dank für Ihr Verständnis. Bei Fragen steht Ihnen unser Support-Team gerne zur Verfügung.<br /><br />
          Freundlichen Grüsse,<br />
          Ihr Side Effects Team
          </p>
      </div>
    </popup>
  </div>
</template>

<script>
import Popup from "@/components/Popup.vue";
import Icon from "@/components/Icon.vue";

export default {
  name: "ImportantNoticePopup",
  components: {
    Popup,
    Icon
  },
  data() {
    return {
      showPopup: false,
      popupKey: 'popup-3'
    };
  },
  created() {
    this.checkPopupStatus();
  },
  methods: {
    checkPopupStatus() {
      const hasSeenPopup = localStorage.getItem(this.popupKey);
      if (!hasSeenPopup) {
        this.showPopup = true;
      }
    },
    handleClose() {
      this.showPopup = false;
      localStorage.setItem(this.popupKey, "true");
    },
  },
};
</script>

<style scoped>
.important-msg {
  min-width: 400px;
  max-width: 100%;
}
</style>

